module.exports = __webpack_public_path__ + "./assets/img_sanchong_color__0aa89781103e1af16abf41ccce301838.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_sanchong_color.jpg
// module id = 632
// module chunks = 12